import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';

import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

export const getCitiesOptionslist = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/super/cities`, {
		headers: {
			token: `${token}`
		}
	});
};

export const createNewHospital = async (data) => {
	const token = getStoredTokenData().token;
	return axios.post(`${API_URL}/api/super/new-hospital`,
        data,
        {
		    headers: {
			token: `${token}`
		}
	});
};

export const getStatsReport = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/hospital/get-stats`, {
		headers: {
			token: `${token}`
		}
	});
};

export const getReportPDF = async ({ hospitalId, startDate, endDate }) => {
	const token = getStoredTokenData().token;
	const url = `${API_URL}/api/hospital/generate-pdf/${hospitalId}?startDate=${startDate}&endDate=${endDate}`;
	return axios.get(url, {
		headers: {
			token: `${token}`
		},
		responseType: 'blob' 
	});
}

export const getStudiesHospital = async ({ role, doctorId, page }) => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/studies/${role}/${doctorId}/${page}`, {
	  headers: {
		token: `${token}`
	  }
	});
  };

export const getAllUsersInfo = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/hospital/get-users`, {
		headers: {
			token: `${token}`
		  }
	})
};

export const deleteUser = async (id) => {
	const token = getStoredTokenData().token;
	return axios.delete(`${API_URL}/api/hospital/delete-users/${id}`, {
		headers: {
			token: `${token}`
		  }
	})
};

export const getSpecificUser = async (id) => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/hospital/get-single-user/${id}`, {
		headers: {
			token: `${token}`
		  }
	})
};

export const getAllUsersHospitalInfo = async ({ hospitalId, role }) => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/hospital/doctors/${hospitalId}/${role ?? ''}`, {
		headers: {
			token: `${token}`
		  }
	})
};